export const environment = {
    // Backend URLs
       backendURL: 'https://aqua-be.agritrack.org/avis-pt', // Production
    // backendURL: 'http://192.168.1.218:5000/avis-be', // [DEV] local
    // backendURL: 'http://192.168.68.101:5000/avis-be', // [DEV] local
    // backendURL: 'http://3.70.20.48:5000/avis-be', // EC2
      // backendURL: 'http://18.192.151.142:5000/avis-be\', // EC2
    // backendURL: 'http://192.168.2.6:5000/avis-be', //Apo home's
    //backendURL: 'https://agritrack.info/avis-be',
     //backendURL: 'http://192.168.150.18:5000/avis-be', // [DEV] local

    // Dashboard URLs
    CarStatusURL: '/stats/status',
    GeneralCarPerSiteInfoURL: '/stats/sites-and-vehicles',
    IdleCarAnalysisURL: '/stats/idle-per-time',
    CarTransactionsURL: '/stats/transactions/state-per-site',
    CarCapacityURL: '/stats/capacity',
    AvgTimeInSiteURL: '/stats/avg-time-in-site',

    // Singleton URLs
    SiteListURL: '/sites/mapping',
    PlateListURL: '/vehicles/plates',

    // Raw Data URLs
    vechilesURL: '/vehicles',
    ordersVechilesURL: '/orders',
    ordersSummaryURL: '/orders/summary',
    transactionsURL: '/transactions',

    // Reports URLs
    inventoryURL: '/inventory',
    compInventoryURL: '/inventory/vrs',
    historyURL: '/vehicles/history',
    compInventoryHistoryURL: '/comparative-inventory',

    // Form URLs
    formURL: '/form',
    formHistoryURL: '/form/history',

    // Auth URLs
    loginURL: '/auth/login',
    changePasswordURL: '/auth/change-password',
    userURL: '/user',
    updateUserInformationURL: '/users',
    rolesURL: '/users/roles',

    // Admin URLs
    usersURL: '/users',
    siteConfigURL: '/readers',

    // Misc
    autoRefresh: 300,
    production: false,
};
